type Level = "info" | "warn" | "error";
type Ctx = Record<string, unknown> | undefined;

let currentUserId: number | null = null;

/** Called by the auth-aware client wrapper so every subsequent log carries user_id. */
export function setLogUser(id: number | string | null | undefined): void {
  if (id === null || id === undefined || id === "") {
    currentUserId = null;
    return;
  }
  const n = typeof id === "number" ? id : Number(id);
  currentUserId = Number.isFinite(n) ? n : null;
}

const SENSITIVE_PARAMS = /^(password|passwd|pw|token|secret|code|key|auth)$/i;

function sanitizeUrl(raw: string): string {
  try {
    const u = new URL(raw);
    for (const k of [...u.searchParams.keys()]) {
      if (SENSITIVE_PARAMS.test(k)) u.searchParams.delete(k);
    }
    return u.toString();
  } catch {
    return raw;
  }
}

function send(level: Level, msg: string, ctx?: Ctx): void {
  if (typeof window === "undefined") return;

  const payload = JSON.stringify({
    level,
    msg,
    ctx,
    url: sanitizeUrl(window.location.href),
    ua: navigator.userAgent,
    userId: currentUserId,
  });

  try {
    if (typeof navigator.sendBeacon === "function") {
      const blob = new Blob([payload], { type: "application/json" });
      if (navigator.sendBeacon("/api/log", blob)) return;
    }
    void fetch("/api/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // never let logging break the app
  }
}

export const log = {
  info: (msg: string, ctx?: Ctx) => send("info", msg, ctx),
  warn: (msg: string, ctx?: Ctx) => send("warn", msg, ctx),
  error: (msg: string, ctx?: Ctx) => send("error", msg, ctx),
};
